import { useState, useRef, useCallback } from 'react';

export function useCarrierRequestSlots() {
    const [timeSlots, setTimeSlots] = useState<any[]>([]);
    const [timeSlotsLoading, setTimeSlotsLoading] = useState(false);
    const [equipmentDetails, setEquipmentDetails] = useState({
        truckNumber: '',
        trailerNumber: '',
        trailerType: 'Van',
        requestedDate: '',
        requestedTime: '',
        requestedUtc: '',
        estimatedPalletCount: 0,
    });
    const timeSlotsRequestId = useRef(0);

    const invalidateTimeSlotsRequest = useCallback(() => {
        timeSlotsRequestId.current += 1;
        setTimeSlots([]);
        setEquipmentDetails(prev => ({ ...prev, requestedTime: '', requestedUtc: '' }));
        setTimeSlotsLoading(false);
    }, []);

    const startTimeSlotsRequest = useCallback(() => {
        return ++timeSlotsRequestId.current;
    }, []);

    const isTimeSlotsRequestValid = useCallback((id: number) => {
        return timeSlotsRequestId.current === id;
    }, []);

    return {
        timeSlots,
        setTimeSlots,
        timeSlotsLoading,
        setTimeSlotsLoading,
        equipmentDetails,
        setEquipmentDetails,
        invalidateTimeSlotsRequest,
        startTimeSlotsRequest,
        isTimeSlotsRequestValid
    };
}
